import { t } from '@lingui/core/macro';
import { useMemo } from 'react';
import { getLabel } from '../../../LanguageConstant';
import Workpage from '../../../components/Workpage/index';
import { useLingui } from '@lingui/react/macro';

type OrgUnitInstitutionsTableProps = {
  setInstitution?: (id: string | undefined) => void;
};

const workpage = {
  scope: {
    workpage: {
      slug: '?institution=',
    },
  },
};

export function OrgUnitInstitutionsTable(_props: OrgUnitInstitutionsTableProps) {
  const { i18n } = useLingui();

  const labels = useMemo(() => {
    return getLabel();
  }, [i18n.locale]);

  const schema = useMemo(
    () => ({
      title: t`Institutions`,
      type: 'workpage',
      elements: [
        {
          title: t`Institutions`,
          type: 'worktray',
          'ui:asCard': false,
          'ui:tableActionsPosition': 'right',
          ':className': 'col-lg-12 px-0',
          resource: `manage/organizationalunit?organizationalUnitTypeNames=${encodeURIComponent('Institución')}&includeAncestors=true`,
          tableActions: [
            {
              label: t`Create Institution`,
              icon: 'phosphor-Plus',
              color: 'info',
              route: '${workpage.slug}new',
              require: [{ permission: 'ManageOrganizationalUnits' }],
            },
          ],
          filters: [
            { title: t`Name`, key: 'name', type: 'string', 'ui:prefix': t`Name`, 'ui:hideLabel': true },
            { title: t`System Code`, key: 'code', type: 'string', 'ui:prefix': t`System Code`, 'ui:hideLabel': true },
            {
              title: t`Sector`,
              key: 'sector',
              arrayKey: 'isInPath',
              type: 'string',
              'ui:prefix': t`Sector`,
              'ui:hideLabel': true,
              'ui:field': 'LookupFormField',
              'ui:hideTitle': true,
              'ui:useTypeahead': true,
              lookup: {
                api: `api:manage/organizationalunit?organizationalUnitTypeNames=${encodeURIComponent('Sector')}`,
                params: {
                  all: true,
                },
                resource: t`Sectors`,
                jnx: 'items',
                id: 'path',
                label: 'name',
              },
            },
            {
              title: t`Category`,
              key: 'category',
              arrayKey: 'isInPath',
              type: 'string',
              'ui:prefix': t`Category`,
              'ui:hideLabel': true,
              'ui:hideTitle': true,
              'ui:field': 'LookupFormField',
              'ui:useTypeahead': true,
              lookup: {
                api: `api:manage/organizationalunit?organizationalUnitTypeNames=${encodeURIComponent('Categoría')}`,
                params: {
                  all: true,
                  'expr:isInPath': 'sector ? sector : null',
                },
                resource: t`Categories`,
                jnx: 'items',
                id: 'path',
                label: 'name',
              },
            },
            {
              title: t`Sub-category`,
              key: 'subcategory',
              arrayKey: 'isInPath',
              type: 'string',
              'ui:prefix': t`Sub-category`,
              'ui:hideLabel': true,
              'ui:hideTitle': true,
              'ui:field': 'LookupFormField',
              'ui:useTypeahead': true,
              lookup: {
                api: `api:manage/organizationalunit?organizationalUnitTypeNames=${encodeURIComponent('Sub-Categoría')}`,
                params: {
                  all: true,
                  'expr:isInPath': 'category ? category : sector ? sector : null',
                },
                resource: t`Sub-categories`,
                jnx: 'items',
                id: 'path',
                label: 'name',
              },
            },
          ],
          columns: [
            {
              title: 'ID',
              sortkey: 'code',
              'map:field': 'code',
            },
            { title: labels.name, sortkey: 'name', 'map:field': { expr: "name & ' ' & ($isTruthy(code) ? '(' & code & ')' : '')" } },
            {
              title: labels.orgPath,
              'map:field': {
                expr: `$isTruthy(ancestors) and $count(ancestors) > 0 ? $join($map(ancestors, function($v) { $v.name }) ,' ⇒ ') : '(${t`First Level Org`})'`,
              },
            },
            {
              title: t`Actions`,
              actions: [
                {
                  label: t`View`,
                  color: 'primary',
                  route: '${workpage.slug}$id',
                },
              ],
            },
          ],
        },
      ],
    }),
    [labels]
  );

  return <Workpage {...workpage} schema={schema} />;
}

export default OrgUnitInstitutionsTable;
